module.exports = __webpack_public_path__ + "img/boho_rio_gift_dancer.101dac05.svg";